import styled from 'styled-components';

export const Wrap = styled.div`
  position: relative;
`;

export const DimmedContent = styled.div`
  opacity: ${({ $loading }) => ($loading ? 0.25 : 1)};
  pointer-events: ${({ $loading }) => ($loading ? 'none' : 'auto')};
  transition: opacity 150ms ease-out;
`;

export const IndicatorLayer = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`;
